import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
var SessionStorageManager = /*#__PURE__*/ function() {
    "use strict";
    function SessionStorageManager() {
        _class_call_check(this, SessionStorageManager);
    }
    SessionStorageManager.getData = function getData(key) {
        try {
            var data = sessionStorage.getItem(key);
            if (data) {
                return JSON.parse(data);
            }
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
        return undefined;
    };
    SessionStorageManager.setData = function setData(key, data) {
        try {
            sessionStorage.setItem(key, JSON.stringify(data));
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
    };
    SessionStorageManager.removeData = function removeData(key) {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
        // TODO: error handling (if necessary?)
        }
    };
    return SessionStorageManager;
}();
export { SessionStorageManager };
